"use client";

import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 */
export const WomenOwned = createSVGIcon(
  <>
    <path
      d="M16.2439 8.60743C16.2442 8.58448 16.2443 8.56149 16.2443 8.53847C16.2443 5.47966 13.7647 3 10.7059 3C7.64707 3 5.16741 5.47966 5.16741 8.53847L5.16699 21H16.2439V8.60743Z"
      fill="#E8E1D2"
    />
    <path
      d="M18.6705 10.5752L18.6704 10.5752V10.5857V17.8495H9.46472V10.4765H8.96587L8.96587 10.4765H9.46587C9.46587 7.93443 11.5266 5.87366 14.0687 5.87366C16.6108 5.87366 18.6716 7.93443 18.6716 10.4765C18.6716 10.5095 18.6712 10.5424 18.6705 10.5752Z"
      stroke="#312921"
    />
  </>,
  "Women owned",
  {
    viewBox: "0 0 24 24",
    titleAccess: "Women owned",
    fill: "none",
  }
);
